export const TELEPHONIST_ROLE = "telephonist.service";

export const LIST_USER_ROLE = [
  {
    roleName: "customer-manager.service",
    roleDisplayName: "Quản lý tổng",
    levels: ["tct", "city"],
  },
  {
    roleName: "Supervisor",
    roleDisplayName: "Giám sát",
    levels: ["tct", "city", "district", "postoffice"],
  },
  {
    roleName: TELEPHONIST_ROLE,
    roleDisplayName: "Điện thoại viên",
    levels: ["postoffice"],
  },
];

export const LIST_USER_LEVEL = [
  {
    value: "tct",
    label: "Tổng công ty",
  },
  { value: "city", label: "Bưu điện tỉnh/thành phố" },
  { value: "district", label: "Bưu điện huyện" },
  { value: "postoffice", label: "Bưu cục" },
];
